import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Card, Grid } from "@material-ui/core";
import Sidebar from "./Sidebar";
import CustomInput from "../components/CustomInput";
import CustomButton from "../components/CustomButton";
import { BLACK } from "../styles/color";
import { validateEmail, validatePinCode } from "../Utils/Validation";
import { toast, ToastContainer } from "react-toastify";
import API_URL, { isProdEnv } from "../ServiceModule/Service";
import axios from "axios";
import { useThemeColors } from "../Context/Theme";
import { formatPhoneNumber, isMobile } from "../global/helpers";
import encryptJSON from "../ServiceModule/Encrypt";
import { getToken, getUserId } from "../LoginModule/LoginUtility";

const Profile = () => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    logo,
    fontSizeHeading,
    fontWeightHeading,
    fontFamilyHeading
  } = useThemeColors();

  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [validPhone, setValidPhone] = useState(true);
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [isValidPinCode, setIsValidPinCode] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const userId = getUserId()
  const token = getToken()

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/readOneUser?user_id=${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = response.data;
      if (userData) {
        const fullName = `${userData.first_name || ""} ${userData.last_name || ""}`.trim();
        setFullName(fullName);
        setEmail(userData.user_email || "");
        setPhoneNumber(userData.phone_number || "");
        setAddress(userData.user_address || "");
        setPincode(userData.zip_code || "");
      }
    } catch (err) {
      console.error("Error fetching user data:", err);
    }
  };

  const updateUser = async () => {
    if (!fullName || !email || !phoneNumber || !pincode) {
      toast.error("Please fill in all the required fields.");
      return;
    }

    if (!isValidEmail || !validPhone || !isValidPinCode) {
      toast.error("Please ensure all inputs are valid.");
      return;
    }

    const [firstName, ...lastNameParts] = fullName.split(/\s+/);
    const lastName = lastNameParts.join(" ");

    setIsSubmitting(true);
    const data = {
      user_id: userId,
      first_name: firstName,
      last_name: lastName,
      user_email: email,
      user_address: address,
      phone_number: phoneNumber,
      zip_code: pincode,
    }

    let payloadJson = null
    if (isProdEnv == "true") {
      const encryptedPayload = encryptJSON(data, "FOAdminCheckAuthorization2025");
      payloadJson = {
        element: encryptedPayload,
      }
    }
    else {
      payloadJson = data
    }
    try {
      const response = await axios.post(`${API_URL}/api/users/updateUserFromWeb`, payloadJson,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Profile Updated Successfully!");
      setIsSubmitting(false);
    } catch (err) {
      console.error("Error updating user data:", err);
      toast.error("Failed to update profile. Please try again.");
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    fetchUserData();
  };

  const validatePhoneInput = (e) => {
    let input = e.target.value;

    // Remove all non-numeric characters
    let numericInput = input.replace(/\D/g, "");

    // Ensure the number does not start with '0'
    if (numericInput.startsWith("0")) {
      setValidPhone(false);
      return;
    }

    // Limit the input to 10 digits
    if (numericInput.length > 10) {
      numericInput = numericInput.slice(0, 10);
    }

    // Update the phone number state
    setPhoneNumber(numericInput);

    // Validate the number if it has exactly 10 digits
    setValidPhone(numericInput.length === 10);
  };

  const handlePincodeChange = (e) => {
    const pin = e.target.value.replace(/\D/g, "");
    setPincode(pin.slice(0, 5));
    setIsValidPinCode(validatePinCode(pin));
  };

  return (
    <div className="overflow-hidden" style={{ backgroundColor: backgroundColor }}>
       <ToastContainer autoClose={2000} />
      <Navbar className="sticky-navbar" />
      <Grid
        container
        spacing={4}
        className=""
        style={{ margin: isMobile() ? "2% 0" : "2% 4%", marginTop: "18vh" }}
      >
        {
          isMobile()
            ? <Sidebar />
            : <Grid item xs={12} sm={10} md={2} className="">
              <Sidebar />
            </Grid>
        }

        {
          isMobile()
            ? <div className="mt-2">
              <Card className="p-5" style={{ borderRadius: "21px", width: isMobile() ? "90%" : "100%" }}>
                <p style={{ fontSize: fontSizeHeading || "28px", fontWeight: fontWeightHeading || "600", fontFamily: fontFamilyHeading }}>Personal Info</p>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomInput
                      type="text"
                      label="Full Name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value.trimStart())}
                      placeholder="Enter your Full Name"
                      required
                      width={"100%"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomInput
                      type="email"
                      label="E-mail"
                      value={email}
                      required
                      onChange={(e) => {
                        const value = e.target.value.trimStart();
                        setEmail(value);
                        setIsValidEmail(validateEmail(value));
                      }}
                      placeholder="Enter your email address"
                      className={!isValidEmail ? "is-invalid" : ""}
                      validationMessage={
                        !isValidEmail ? "Please enter a valid email address." : ""
                      }
                      width={"100%"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomInput
                      label="Phone"
                      value={phoneNumber?.length > 0 ? formatPhoneNumber(phoneNumber) : phoneNumber}
                      onChange={validatePhoneInput}
                      placeholder="Enter your number"
                      className={
                        !validPhone && phoneNumber.length > 0 ? "is-invalid" : ""
                      }
                      validationMessage={
                        !validPhone ? "Please enter a valid Phone Number." : ""
                      }
                      required
                      width={"100%"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomInput
                      label="Zip code"
                      value={pincode}
                      onChange={handlePincodeChange}
                      placeholder="Enter your zipcode"
                      className={!isValidPinCode ? "is-invalid" : ""}
                      validationMessage={
                        !isValidPinCode ? "Please enter a valid zipcode." : ""
                      }
                      required
                      width={"100%"}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  xs={12}
                  className="pb-4"
                  style={{ borderBottom: "1px solid #E6E8EC" }}
                ></Grid>
                <Grid container spacing={4}>
                  <Grid item xs={6}>
                    <CustomButton
                      text="Update Profile"
                      size="lg"
                      block
                      className="mt-4 mb-3"

                      onClick={updateUser}
                      onLoading={isSubmitting}
                      disabled={isSubmitting}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CustomButton
                      text="Cancel"
                      size="lg"
                      block
                      className="mt-4 mb-3"
                      bgcolor="black"
                      onClick={handleCancel}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>
              </Card>
            </div>
            : <Grid item xs={12} sm={10} md={8}>
              <Card className="p-5" style={{ borderRadius: "21px", width: isMobile() ? "90%" : "100%" }}>
                <p style={{ fontSize: fontSizeHeading || "28px", fontWeight: fontWeightHeading || "600", fontFamilyHeading }}>Personal Info</p>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomInput
                      type="text"
                      label="Full Name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      placeholder="Enter your Full Name"
                      required
                      width={"100%"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomInput
                      type="email"
                      label="E-mail"
                      value={email}
                      required
                      onChange={(e) => {
                        const value = e.target.value;
                        setEmail(value);
                        setIsValidEmail(validateEmail(value));
                      }}
                      placeholder="Enter your email address"
                      className={!isValidEmail ? "is-invalid" : ""}
                      validationMessage={
                        !isValidEmail ? "Please enter a valid email address." : ""
                      }
                      width={"100%"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomInput
                      label="Phone"
                      value={phoneNumber?.length > 0 ? formatPhoneNumber(phoneNumber) : phoneNumber}
                      onChange={validatePhoneInput}
                      placeholder="Enter your number"
                      className={
                        !validPhone && phoneNumber.length > 0 ? "is-invalid" : ""
                      }
                      validationMessage={
                        !validPhone ? "Please enter a valid Phone Number." : ""
                      }
                      required
                      width={"100%"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <CustomInput
                      label="Zip code"
                      value={pincode}
                      onChange={handlePincodeChange}
                      placeholder="Enter your zipcode"
                      className={!isValidPinCode ? "is-invalid" : ""}
                      validationMessage={
                        !isValidPinCode ? "Please enter a valid zipcode." : ""
                      }
                      required
                      width={"100%"}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  xs={12}
                  className="pb-4"
                  style={{ borderBottom: "1px solid #E6E8EC" }}
                ></Grid>
                <Grid container spacing={4}>
                  <Grid item xs={6}>
                    <CustomButton
                      text="Update Profile"
                      size="lg"
                      block
                      className="mt-4 mb-3"

                      onClick={updateUser}
                      onLoading={isSubmitting}
                      disabled={isSubmitting}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CustomButton
                      text="Cancel"
                      size="lg"
                      block
                      className="mt-4 mb-3"
                      bgcolor="black"
                      onClick={handleCancel}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
        }

      </Grid>
      <Footer />
    </div>
  );
};

export default Profile;
